import axios, { AxiosResponse } from "axios";

import { ICreateAppPayload, ICreatedAppValues, IDefaultContentResponse, IValidateCode, IValidateCodeResponse, IValidateEmail } from "../../interfaces/api";
import HTTP from "../../services/http.service";

export function getDefaultContent(): Promise<AxiosResponse<IDefaultContentResponse>> {
    return HTTP.get(`/api/self-sign-up/defaultContent`);
}

export function validateEmailAddress(params: IValidateEmail) {
    return HTTP.post(`/api/self-sign-up/validate`, params );
}

export function validateCode(params: IValidateCode): Promise<AxiosResponse<IValidateCodeResponse>>  {
    return HTTP.post(`/api/self-sign-up/code`, params);
}

export function createApp(params: ICreateAppPayload): Promise<AxiosResponse<ICreatedAppValues>>{
    return HTTP.post(`/api/self-sign-up/create`, params);
}